import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import type { Article } from '@/types/content';

const list = articles as Article[];

export default function WeeklySection() {
  const weekly = list.filter((a) => a.category === 'weekly' || a.featured).slice(0, 3);

  return (
    <section id="weekly" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Weekly"
          title="本周推荐"
          desc="编辑手工筛过的本周精选，只留下值得花时间的那些。更新时间固定在每周一，宁可少一点，也要耐看一点。"
          linkTo="/topics?cat=weekly"
          linkLabel="查看本周精选"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {weekly.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}